import React, { useId, useState } from "react";

export default function TheGapSection({ aiData }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionId = useId();
if (!aiData?.gap) return null;
  return (
    <section className="the-gap-section">
      <div className="container">
        <div className="row justify-content-between the-gap-row">
          <div className="col-lg-5">
            <span className="main-title">{aiData?.gap?.eyebrow}</span>
            <h2 className="heading">{aiData?.gap?.title}</h2>
          </div>
          <div className="col-lg-6">
            <div className="the-gap-intro">
             {aiData?.gap?.paragraphs?.map((paragraph, index) => ( <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} /> ))}
            </div>
              <div className="the-gap-accordion">
              {aiData?.gap?.faqs?.map((item, index) => {
                const isOpen = activeIndex === index;
                const triggerId = `${sectionId}-trigger-${index}`;
                const panelId = `${sectionId}-panel-${index}`;

                return (
                  <div className="the-gap-item" key={index}>
                    <h3 className="the-gap-item-heading">
                      <button    className="the-gap-trigger"  type="button"
                        id={triggerId} aria-expanded={isOpen}  aria-controls={panelId}  onClick={() =>  setActiveIndex(isOpen ? null : index) }  >
                        <span>{item?.question}</span>
                        <span className="the-gap-toggle"   aria-hidden="true" >   {isOpen ? "×" : "+"}  </span>
                      </button>
                    </h3>

                    <div  id={panelId} role="region"  aria-labelledby={triggerId}  hidden={!isOpen}  >
                      <p className="the-gap-answer">
                        {item?.answer}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



